export const homepageImages = {
  hero: '/images/Homepage/homepage-hero.png',
  univers: {
    talents: '/images/Homepage/homepage-talents.png',
    carrieres: '/images/Homepage/homepage-carrieres.png',
    sante: '/images/Homepage/homepage-sante.png',
    education: '/images/Homepage/homepage-education.png',
    viePerso: '/images/Homepage/homepage-vie-perso.png',
  },
  universIcons: {
    talents: '/icons/talents.svg',
    carrieres: '/icons/carriere.svg',
    sante: '/icons/sante.svg',
    education: '/icons/education.svg',
    viePerso: '/icons/vie.svg',
  },
  tools: {
    tests: '/images/Homepage/homepage-outils-tests.png',
    seriousGames: '/images/Homepage/homepage-outils-serious-games.png',
    ebooks: '/images/Homepage/homepage-ebooks-guides.png',
  },
} as const;
